import React, { Component } from 'react';
import {
  
} from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from '../../constant/Utils';

import logo from '../../images/logo.png';
import searchBtn from '../../images/searchBtn.png';
import menuIcon from '../../images/menuIcon.png';
import footerLogo from '../../images/footerLogo.png';

import './header.css'; 

class Header extends Component {

	constructor(props, context) {
	    super(props, context);
	    this.state = {
	    	menuOpened: false,
	    	geOpened: false,
	    	aeOpened: false,
	    	searchText: "",
	    	userToken: ""
	    };
    }

	componentWillMount() {
		let token = window.localStorage.getItem("token");
		if (token) {
			this.setState({ userToken: token });
		}
	}


	render() {

		// const headerArr = [
		// 	{ name: "General\ninformation", url: "/general-information", keyUrl: "ge" },{ name: "AE\nmanagement", url: "/ae-management", keyUrl: "ae" },{ name: "Case sharing", url: "/case-sharing", keyUrl: "case-sharing" },
		// 	{ name: "Past conference\nvideos", url: "/past-conference-videos", keyUrl: "past-conference-videos" },{ name: "Slide decks", url: "/slide-decks", keyUrl: "slide-decks" },{ name: "News and updates", url: "/news-and-updates", keyUrl: "news-and-updates" }
		// ];

		const headerArr = [
			{ name: "General\ninformation", url: "/general-information", keyUrl: "ge" },{ name: "AE\nmanagement", url: "/ae-management", keyUrl: "ae" },
			{ name: "Slide decks", url: "/slide-decks", keyUrl: "slide-decks" },{ name: "News and updates", url: "/news-and-updates", keyUrl: "news-and-updates" }
		];


		return(
			<div>
				<div className="header containerMaxWidth">
					<a className="headerLogo" href="/"><img src={logo} /></a>
					<div className="desktopMenu">
						<div className="supperHeader">
							<div className="searchInput">
								<input type="text" placeholder="Search" onChange={(e) => this.setState({ searchText: e.target.value })} />
								<img className="submitBtn" src={searchBtn} onClick={() => { if (this.state.searchText.length > 0) { window.location.href = "/searchResult/"+this.state.searchText } }} />
							</div>
							{
								(this.state.userToken) ? (
									<div className="loginInput actionBtn">
										<a href="/account">
											<div>
												<span>MY ACCOUNT</span>
											</div>
										</a>
									</div>

								) : (
									<div className="loginInput actionBtn">
										<a href="/login">
											<div>
												<span>LOGIN</span>
											</div>
										</a>
									</div>
								)
							}
							
						</div>
						<div className="headerMenu">
							<a className={(this.props.urlKey === 'ge') ? "headerMenuItem active" : "headerMenuItem" }>
								<div><span>General information</span></div>
								<div className="subHeaderMenu">
									<a href="/general-information/dosage-and-administration" className={(this.props.moduleType === 'dosage-and-administration') ? "headerMenuItem active" : "headerMenuItem" }><div><span>Dosage and administration</span></div></a>
									<a href="/general-information/overall-safety-profile" className={(this.props.moduleType === 'overall-safety-profile') ? "headerMenuItem active" : "headerMenuItem" }><div><span>Overall safety profile</span></div></a>
								</div>
							</a>
							<a className={(this.props.urlKey === 'ae') ? "headerMenuItem active" : "headerMenuItem" }>
								<div><span>AE management</span></div>
								<div className="subHeaderMenu">
									<a href="/special-warning" className={(this.props.moduleType === 'special-warning') ? "headerMenuItem active" : "headerMenuItem" }><div><span><nobr>Special warnings</nobr> and precautions for use</span></div></a>
									<a href="/common-ars" className={(this.props.moduleType === 'common-ars') ? "headerMenuItem active" : "headerMenuItem" }><div><span>Common ARs</span></div></a>
								</div>
							</a>
							<a href="/slide-decks" className={(this.props.urlKey === 'slide-decks') ? "headerMenuItem active" : "headerMenuItem" }><div><span>Slide decks</span></div></a>
							<a href="/news-and-updates" className={(this.props.urlKey === 'news-and-updates') ? "headerMenuItem active" : "headerMenuItem" }><div><span>News and updates</span></div></a>
						</div>
					</div>

					<div className="mobileMenu">
						<img className="menuIcon" src={menuIcon} onClick={() => { this.setState({ menuOpened: true }) }} />
						<div className={ this.state.menuOpened ? "dimPopup active" : "dimPopup" } onClick={() => { this.setState({ menuOpened: false }) }} />
						<div className={ this.state.menuOpened ? "mobileMenuBox active" : "mobileMenuBox" }>
							<div className="supperHeader">
								<div className="searchInput">
									<input type="text" placeholder="Search" onChange={(e) => this.setState({ searchText: e.target.value })} />
									<img className="submitBtn" src={searchBtn} onClick={() => { if (this.state.searchText.length > 0) { window.location.href = "/searchResult/"+this.state.searchText } }} />
								</div>
							</div>
							<div className="headerMenu">
								<a className={(this.props.urlKey === 'ge') ? "headerMenuItem active" : "headerMenuItem" }>
									<div onClick={() => this.setState({ geOpened: !this.state.geOpened })}><span>General information</span></div>
									<div className={(this.state.geOpened) ? "subHeaderMenu active" : "subHeaderMenu"}>
										<a href="/general-information/dosage-and-administration" className={(this.props.moduleType === 'dosage-and-administration') ? "headerMenuItem active" : "headerMenuItem" }><div><span>Dosage and administration</span></div></a>
										<a href="/general-information/overall-safety-profile" className={(this.props.moduleType === 'overall-safety-profile') ? "headerMenuItem active" : "headerMenuItem" }><div><span>Overall safety profile</span></div></a>
									</div>
								</a>
								<a className={(this.props.urlKey === 'ae') ? "headerMenuItem active" : "headerMenuItem" }>
									<div onClick={() => this.setState({ aeOpened: !this.state.aeOpened })}><span>AE management</span></div>
									<div className={(this.state.aeOpened) ? "subHeaderMenu active" : "subHeaderMenu"}>
										<a href="/special-warning" className={(this.props.moduleType === 'special-warning') ? "headerMenuItem active" : "headerMenuItem" }><div><span><nobr>Special warnings</nobr> and precautions for use</span></div></a>
										<a href="/common-ars" className={(this.props.moduleType === 'common-ars') ? "headerMenuItem active" : "headerMenuItem" }><div><span>Common ARs</span></div></a>
									</div>
								</a>
								<a href="/slide-decks" className={(this.props.urlKey === 'slide-decks') ? "headerMenuItem active" : "headerMenuItem" }><div><span>Slide decks</span></div></a>
								<a href="/news-and-updates" className={(this.props.urlKey === 'news-and-updates') ? "headerMenuItem active" : "headerMenuItem" }><div><span>News and updates</span></div></a>
							
							</div>
							<div className="supperHeader">
								<div className="loginInput actionBtn">
									<a href="/login">
										<div>
											<span>LOGIN</span>
										</div>
									</a>
								</div>
							</div>
						</div>
						
					</div>
				</div>
			</div>
		);
	}

}

const mapStateToProps = (state) => {
  return {

  };
}

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  {  }
)(Header));